import React from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import PrototypeHero from "../../assets/prototypeHero.jpg";
import ProvenImage from "../../assets/Proven.jpg";
import { TbStopwatch, TbDoorEnter } from "react-icons/tb";
import { IoMdSearch } from "react-icons/io";
import { PiCubeFocusLight } from "react-icons/pi";
import { AiOutlineGlobal } from "react-icons/ai";
import { GoShieldCheck } from "react-icons/go";
import { AiOutlineMergeCells } from "react-icons/ai";
import SixDevelopment from "../../assets/sixDevelopment.jpg";

const PrototypeSprint = () => {
  const handleTalkToTeam = () => {
    window.location.href = "/contact-us";
  };
  const handleGoToProducts = () => {
    window.location.href = "/products";
  };

  return (
    <>
      <Helmet>
        <title>Medichy | Prototype Sprint</title>
        <meta
          name="description"
          content="Medichy offers comprehensive medical device design services with expertise in minimally invasive devices, catheter technologies, and regulatory compliance."
        />
      </Helmet>
      <ThePrototypeSprint>
        <div className="contact-hero-section">
          <img src={PrototypeHero} alt="page banner" />
          <div className="overlay"></div>
          <div className="hero-content">
            <h3>
              Unblock projects and scale faster with an embedded partner you can
              trust.
            </h3>
            <p>
              Medichy acts as an extension of your R&D, delivering speed,
              compliance, and scalable manufacturing through global facilities.
            </p>
            <button className="btn-secondary" onClick={handleGoToProducts}>
              VIEW AVAILABLE PRODUCTS
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="container">
          <div className="proven-outcomes">
            <div className="section-header">
              <h3>Proven outcomes, less risk</h3>
              <p className="section-subtitle">
                Whether you are a startup needing momentum or an OEM unblocking
                a stalled project, the Sprint gives you a proven way to
                accelerate development with less risk.
              </p>
            </div>

            <div className="proven-content">
              <div className="proven-image">
                <img src={ProvenImage} alt="provenImage" />
                <div className="image-overlay-card"></div>
              </div>
              <div className="proven-content-writeUps">
                <div className="outcome-list">
                  <div className="outcome-item">
                    <span className="icon-wrapper">
                      <TbStopwatch />
                    </span>
                    <span className="outcome-text">
                      Structured 90 to 180 day process
                    </span>
                  </div>
                  <div className="outcome-item">
                    <span className="icon-wrapper">
                      <TbDoorEnter />
                    </span>
                    <span className="outcome-text">
                      Fully functional prototype at the end
                    </span>
                  </div>
                  <div className="outcome-item">
                    <span className="icon-wrapper">
                      <IoMdSearch />
                    </span>
                    <span className="outcome-text">
                      Regulatory clarity from day one
                    </span>
                  </div>
                  <div className="outcome-item">
                    <span className="icon-wrapper">
                      <PiCubeFocusLight />
                    </span>
                    <span className="outcome-text">
                      Confidence to move into full development or scale
                    </span>
                  </div>
                </div>

                <button className="btn-secondary" onClick={handleTalkToTeam}>
                  TALK TO OUR TEAM
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <div className="prototype-sprint-section">
            <div className="section-header">
              <h3>Your first step: The Prototype Sprint</h3>
              <p className="section-subtitle">
                The Prototype Sprint is a structured, fixed-scope engagement
                that delivers a manufacturable prototype and regulatory clarity.
                It gives you momentum and confidence to move forward.
              </p>
              <button className="btn-primary" onClick={handleTalkToTeam}>
                Explore The Sprint
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                  />
                </svg>
              </button>
            </div>

            <div className="sprint-timeline">
              <div className="timeline-container">
                <div className="timeline-path">
                  <div className="timeline-line"></div>
                  <div className="timeline-dots">
                    {[1, 2, 3, 4, 5, 6].map((dot) => (
                      <div key={dot} className="timeline-dot"></div>
                    ))}
                  </div>
                </div>

                <div className="timeline-cards">
                  <div className="timeline-card">
                    <div className="card-header">
                      <div className="card-number">01</div>
                      <div className="card-phase">Requirements</div>
                    </div>
                    <div className="card-history">
                      <div className="history-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                          <path d="M9.5 13a.5.5 0 0 1-.5-.5V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L10 5.707V12.5a.5.5 0 0 1-.5.5z" />
                        </svg>
                      </div>
                    </div>
                    <h4 className="card-title">Define User Requirements</h4>
                    <p className="card-description">
                      Identify and document user needs, clinical requirements,
                      and technical specifications.
                    </p>
                  </div>

                  <div className="timeline-card">
                    <div className="card-header">
                      <div className="card-number">02</div>
                      <div className="card-phase">Concept</div>
                    </div>
                    <div className="card-history">
                      <div className="history-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                          <path d="M9.5 13a.5.5 0 0 1-.5-.5V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L10 5.707V12.5a.5.5 0 0 1-.5.5z" />
                        </svg>
                      </div>
                    </div>
                    <h4 className="card-title">Group Ideation</h4>
                    <p className="card-description">
                      Collaborative brainstorming sessions to generate multiple
                      design concepts and approaches.
                    </p>
                  </div>

                  <div className="timeline-card">
                    <div className="card-header">
                      <div className="card-number">03</div>
                      <div className="card-phase">Development</div>
                    </div>
                    <div className="card-history">
                      <div className="history-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                          <path d="M9.5 13a.5.5 0 0 1-.5-.5V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L10 5.707V12.5a.5.5 0 0 1-.5.5z" />
                        </svg>
                      </div>
                    </div>
                    <h4 className="card-title">Select Designs</h4>
                    <p className="card-description">
                      Evaluate and select the most promising designs based on
                      feasibility and requirements.
                    </p>
                  </div>

                  <div className="timeline-card">
                    <div className="card-header">
                      <div className="card-number">04</div>
                      <div className="card-phase">1st Prototype</div>
                    </div>
                    <div className="card-history">
                      <div className="history-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                          <path d="M9.5 13a.5.5 0 0 1-.5-.5V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L10 5.707V12.5a.5.5 0 0 1-.5.5z" />
                        </svg>
                      </div>
                    </div>
                    <h4 className="card-title">Produce Physical Models</h4>
                    <p className="card-description">
                      Create initial physical prototypes for testing and
                      validation with stakeholders.
                    </p>
                  </div>

                  <div className="timeline-card">
                    <div className="card-header">
                      <div className="card-number">05</div>
                      <div className="card-phase">Refinement</div>
                    </div>
                    <div className="card-history">
                      <div className="history-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                          <path d="M9.5 13a.5.5 0 0 1-.5-.5V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L10 5.707V12.5a.5.5 0 0 1-.5.5z" />
                        </svg>
                      </div>
                    </div>
                    <h4 className="card-title">Select One Design</h4>
                    <p className="card-description">
                      Based on testing results, choose the optimal design for
                      final development.
                    </p>
                  </div>

                  <div className="timeline-card">
                    <div className="card-header">
                      <div className="card-number">06</div>
                      <div className="card-phase">2nd Prototype</div>
                    </div>
                    <div className="card-history">
                      <div className="history-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                          <path d="M9.5 13a.5.5 0 0 1-.5-.5V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L10 5.707V12.5a.5.5 0 0 1-.5.5z" />
                        </svg>
                      </div>
                    </div>
                    <h4 className="card-title">Based On Refined Design</h4>
                    <p className="card-description">
                      Create the final manufacturable prototype ready for
                      regulatory submission.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="manufacturing-capacity">
            <div className="section-header">
              <h3>The foundations of Sprint success</h3>
              <p className="section-subtitle">
                Behind every Sprint are four principles that give you clarity,
                speed, and confidence – the same principles that define how
                Medichy delivers across all projects.
              </p>
            </div>

            <div className="capacity-cards">
              <div className="capacity-card">
                <div className="card-icon">
                  <TbStopwatch />
                </div>
                <h5 className="card-title">Speed with Structure</h5>
                <p>
                  From concept to prototype in 90 to 180 days, with clarity at
                  every step.
                </p>
              </div>
              <div className="capacity-card">
                <div className="card-icon">
                  <AiOutlineMergeCells />
                </div>
                <h5 className="card-title">Integrated Model</h5>
                <p>
                  Design, engineering, and regulatory aligned in one accountable
                  partner.
                </p>
              </div>
              <div className="capacity-card">
                <div className="card-icon">
                  <GoShieldCheck />
                </div>
                <h5 className="card-title">Regulatory Built-In</h5>
                <p>Compliance from day one, no costly rework later.</p>
              </div>
              <div className="capacity-card">
                <div className="card-icon">
                  <AiOutlineGlobal />
                </div>
                <h5 className="card-title">Global Execution</h5>
                <p>Future-proofed for scale with Global capacity.</p>
              </div>
            </div>
          </div>

          <div className="six-development-section">
            <div className="six-development-image">
              <img src={SixDevelopment} alt="sixDevelopmentImage" />
              <div className="image-overlay-card"></div>
            </div>
            <div className="six-development-content">
              <h4>Ready to Start Your Sprint?</h4>
              <p>
                Contact our team today to discuss how our structured Prototype
                Sprint can accelerate your medical device development with
                regulatory clarity and manufacturable prototypes.
              </p>
              <button className="btn-primary" onClick={handleTalkToTeam}>
                START YOUR SPRINT
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </ThePrototypeSprint>
    </>
  );
};

const ThePrototypeSprint = styled.div`
  width: 100%;
  min-height: 100vh;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  .contact-hero-section {
    position: relative;
    height: 70vh;
    width: 100%;
    overflow: hidden;
    margin-bottom: 4rem;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        rgba(0, 100, 200, 0.85) 0%,
        rgba(0, 50, 150, 0.9) 100%
      );
    }

    .hero-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #fff;
      width: 90%;
      max-width: 900px;
      padding: 0 1rem;

      h3 {
        font-size: 2.5rem;
        font-weight: 700;
        margin-bottom: 1.5rem;
        text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
        line-height: 1;
      }

      p {
        font-size: 1rem;
        font-weight: 400;
        opacity: 0.95;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
        margin-bottom: 2rem;
        line-height: 1.6;
        max-width: 700px;
        margin-left: auto;
        margin-right: auto;
      }

      .btn-secondary {
        display: inline-flex;
        align-items: center;
        gap: 0.75rem;
        background: transparent;
        color: white;
        border: 2px solid white;
        padding: 1rem 2.5rem;
        font-size: 1.1rem;
        font-weight: 600;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        &:hover {
          background: white;
          color: #3182ce;
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(255, 255, 255, 0.2);

          svg {
            transform: translateX(5px);
          }
        }

        svg {
          transition: transform 0.3s ease;
        }
      }
    }
  }

  .section-header {
    text-align: center;
    margin-bottom: 4rem;

    h3 {
      font-size: 2.5rem;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 1rem;
    }

    .section-subtitle {
      font-size: 1.25rem;
      color: #666;
      line-height: 1.6;
      max-width: 800px;
      margin: 0 auto 1.5rem;
    }

    .btn-primary {
      display: inline-flex;
      align-items: center;
      gap: 0.75rem;
      background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);
      color: white;
      border: none;
      padding: 1rem 2.5rem;
      font-size: 1.1rem;
      font-weight: 600;
      border-radius: 50px;
      cursor: pointer;
      transition: all 0.3s ease;
      text-transform: uppercase;
      letter-spacing: 0.5px;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(49, 130, 206, 0.4);

        svg {
          transform: translateX(5px);
        }
      }

      svg {
        transition: transform 0.3s ease;
      }
    }
  }

  .proven-outcomes {
    padding: 4rem 0;

    .proven-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 4rem;
      align-items: center;
      margin-top: 3rem;

      .proven-image {
        position: relative;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
        height: 400px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .image-overlay-card {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            to right,
            rgba(0, 100, 200, 0.1),
            transparent
          );
        }

        &:hover img {
          transform: scale(1.05);
        }
      }

      .proven-content-writeUps {
        .outcome-list {
          margin-bottom: 2.5rem;

          .outcome-item {
            display: flex;
            align-items: center;
            gap: 1rem;
            margin-bottom: 1.5rem;
            padding: 1rem;
            background: white;
            border-radius: 12px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
            border: 1px solid #e2e8f0;
            transition: all 0.3s ease;

            &:hover {
              transform: translateY(-4px);
              box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
            }

            .icon-wrapper {
              width: 50px;
              height: 50px;
              background: linear-gradient(135deg, #3182ce, #2c5282);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
              color: white;
              font-size: 1.5rem;
            }

            .outcome-text {
              font-size: 1.1rem;
              font-weight: 500;
              color: #1a1a1a;
              line-height: 1.4;
            }
          }
        }

        .btn-secondary {
          display: inline-flex;
          align-items: center;
          gap: 0.75rem;
          background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);
          color: white;
          border: none;
          padding: 1rem 2.5rem;
          font-size: 1.1rem;
          font-weight: 600;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
          text-transform: uppercase;
          letter-spacing: 0.5px;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(49, 130, 206, 0.4);

            svg {
              transform: translateX(5px);
            }
          }

          svg {
            transition: transform 0.3s ease;
          }
        }
      }
    }
  }

  .prototype-sprint-section {
    padding: 4rem 0;
    background: #f8fafc;
    border-radius: 24px;
    margin: 4rem 0;

    .sprint-timeline {
      margin-top: 4rem;

      .timeline-container {
        position: relative;
        max-width: 1000px;
        margin: 0 auto;

        .timeline-path {
          position: absolute;
          top: 120px;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(135deg, #3182ce, #2c5282);
          z-index: 1;

          .timeline-line {
            width: 100%;
            height: 100%;
          }

          .timeline-dots {
            position: absolute;
            top: -8px;
            left: 0;
            right: 0;
            display: flex;
            justify-content: space-between;

            .timeline-dot {
              width: 20px;
              height: 20px;
              background: white;
              border: 4px solid #3182ce;
              border-radius: 50%;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            }
          }
        }

        .timeline-cards {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 2rem;
          position: relative;
          z-index: 2;

          .timeline-card {
            background: white;
            border-radius: 16px;
            padding: 2rem;
            box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
            border: 1px solid #e2e8f0;
            transition: all 0.3s ease;

            &:hover {
              transform: translateY(-8px);
              box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
            }

            .card-header {
              display: flex;
              align-items: center;
              gap: 1rem;
              margin-bottom: 1rem;

              .card-number {
                width: 40px;
                height: 40px;
                background: linear-gradient(135deg, #3182ce, #2c5282);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: white;
                font-weight: 700;
                font-size: 1rem;
              }

              .card-phase {
                font-size: 1rem;
                font-weight: 600;
                color: #3182ce;
                text-transform: uppercase;
                letter-spacing: 0.5px;
              }
            }

            .card-history {
              display: flex;
              align-items: center;
              gap: 0.5rem;
              margin-bottom: 1.5rem;
              padding-bottom: 1rem;
              border-bottom: 1px solid #e2e8f0;

              .history-icon {
                width: 24px;
                height: 24px;
                background: #f0f9ff;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #3182ce;
                font-size: 0.875rem;
              }

              .history-text {
                font-size: 0.875rem;
                color: #718096;
                font-weight: 500;
              }
            }

            .card-title {
              font-size: 1.25rem;
              font-weight: 700;
              color: #1a1a1a;
              margin-bottom: 0.75rem;
              line-height: 1.3;
            }

            .card-description {
              font-size: 1rem;
              color: #666;
              line-height: 1.6;
              margin: 0;
            }
          }
        }
      }
    }
  }

  .manufacturing-capacity {
    padding: 4rem 0;

    .capacity-cards {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 2rem;
      margin-top: 3rem;

      .capacity-card {
        background: white;
        border-radius: 16px;
        padding: 2rem;
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
        text-align: center;
        border: 1px solid #e2e8f0;

        &:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
        }

        .card-icon {
          width: 70px;
          height: 70px;
          background: linear-gradient(135deg, #3182ce, #2c5282);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          color: white;
          font-size: 2rem;
        }

        .card-title {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 1rem;
        }

        p {
          font-size: 1rem;
          color: #666;
          line-height: 1.6;
          margin: 0;
        }
      }
    }
  }

  .six-development-section {
    padding: 4rem 0;
    background: #f8fafc;
    border-radius: 24px;
    margin: 4rem 0;

    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4rem;
    align-items: center;

    .six-development-image {
      position: relative;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
      height: 400px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;
      }

      .image-overlay-card {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          to right,
          rgba(0, 100, 200, 0.1),
          transparent
        );
      }

      &:hover img {
        transform: scale(1.05);
      }
    }

    .six-development-content {
      h4 {
        font-size: 2rem;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 1.5rem;
        position: relative;
        display: inline-block;

        &:after {
          content: "";
          position: absolute;
          bottom: -8px;
          left: 0;
          width: 60px;
          height: 4px;
          background: linear-gradient(135deg, #3182ce, #2c5282);
          border-radius: 2px;
        }
      }

      p {
        font-size: 1.1rem;
        color: #666;
        line-height: 1.6;
        margin-bottom: 2.5rem;
      }

      .btn-primary {
        display: inline-flex;
        align-items: center;
        gap: 0.75rem;
        background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);
        color: white;
        border: none;
        padding: 1rem 2.5rem;
        font-size: 1.1rem;
        font-weight: 600;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(49, 130, 206, 0.4);

          svg {
            transform: translateX(5px);
          }
        }

        svg {
          transition: transform 0.3s ease;
        }
      }
    }
  }

  /* Media Queries */
  @media screen and (max-width: 1366px) {
    .contact-hero-section {
      height: 65vh;

      .hero-content {
        h3 {
          font-size: 3.25rem;
        }

        p {
          font-size: 1.2rem;
        }
      }
    }

    .container {
      padding: 0 1.5rem;
    }

    .section-header {
      h3 {
        font-size: 2.25rem;
      }
    }

    .proven-outcomes {
      .proven-content {
        gap: 3rem;

        .proven-image {
          height: 350px;
        }
      }
    }

    .prototype-sprint-section {
      .sprint-timeline {
        .timeline-container {
          .timeline-path {
            top: 100px;
          }

          .timeline-cards {
            .timeline-card {
              padding: 1.5rem;
            }
          }
        }
      }
    }

    .manufacturing-capacity {
      .capacity-cards {
        .capacity-card {
          padding: 1.5rem;
        }
      }
    }

    .six-development-section {
      .six-development-image {
        height: 350px;
      }
    }
  }

  @media screen and (max-width: 1200px) {
    .contact-hero-section {
      height: 60vh;

      .hero-content {
        h3 {
          font-size: 3rem;
        }
      }
    }

    .prototype-sprint-section {
      .sprint-timeline {
        .timeline-container {
          .timeline-path {
            top: 90px;
          }

          .timeline-cards {
            grid-template-columns: repeat(2, 1fr);
          }
        }
      }
    }

    .manufacturing-capacity {
      .capacity-cards {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    .proven-outcomes {
      .proven-content {
        .proven-image {
          height: 320px;
        }
      }
    }

    .six-development-section {
      .six-development-image {
        height: 320px;
      }
    }
  }

  @media screen and (max-width: 900px) {
    .contact-hero-section {
      height: 55vh;
      margin-bottom: 3rem;

      .hero-content {
        h3 {
          font-size: 2.5rem;
        }

        p {
          font-size: 1.1rem;
          margin-bottom: 1.5rem;
        }

        .btn-secondary {
          padding: 0.875rem 2rem;
          font-size: 1rem;
        }
      }
    }

    .container {
      padding: 0 1rem;
    }

    .section-header {
      margin-bottom: 3rem;

      h3 {
        font-size: 2rem;
      }

      .section-subtitle {
        font-size: 1.1rem;
      }

      .btn-primary {
        padding: 0.875rem 2rem;
        font-size: 1rem;
      }
    }

    .proven-outcomes {
      padding: 3rem 0;

      .proven-content {
        grid-template-columns: 1fr;
        gap: 3rem;

        .proven-image {
          height: 300px;
          order: 2;
        }

        .proven-content-writeUps {
          order: 1;

          .outcome-list {
            .outcome-item {
              padding: 0.875rem;
              margin-bottom: 1rem;

              .icon-wrapper {
                width: 45px;
                height: 45px;
                font-size: 1.25rem;
              }

              .outcome-text {
                font-size: 1rem;
              }
            }
          }

          .btn-secondary {
            padding: 0.875rem 2rem;
            font-size: 1rem;
          }
        }
      }
    }

    .prototype-sprint-section {
      padding: 3rem 0;
      margin: 3rem 0;
      border-radius: 16px;

      .sprint-timeline {
        margin-top: 3rem;

        .timeline-container {
          .timeline-path {
            display: none;
          }

          .timeline-cards {
            grid-template-columns: 1fr;
            max-width: 500px;
            margin: 0 auto;
            gap: 1.5rem;

            .timeline-card {
              padding: 1.5rem;
            }
          }
        }
      }
    }

    .manufacturing-capacity {
      padding: 3rem 0;

      .capacity-cards {
        grid-template-columns: 1fr;
        max-width: 400px;
        margin: 3rem auto 0;
        gap: 1.5rem;

        .capacity-card {
          padding: 1.5rem;

          .card-icon {
            width: 60px;
            height: 60px;
            font-size: 1.75rem;
          }
        }
      }
    }

    .six-development-section {
      padding: 3rem 0;
      margin: 3rem 0;
      border-radius: 16px;
      grid-template-columns: 1fr;
      gap: 3rem;

      .six-development-image {
        height: 300px;
        order: 2;
      }

      .six-development-content {
        order: 1;

        h4 {
          font-size: 1.5rem;
        }

        p {
          font-size: 1rem;
        }

        .btn-primary {
          padding: 0.875rem 2rem;
          font-size: 1rem;
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    .contact-hero-section {
      height: 50vh;

      .hero-content {
        h3 {
          font-size: 2rem;
          margin-bottom: 1rem;
        }

        p {
          font-size: 1rem;
          margin-bottom: 1.5rem;
        }

        .btn-secondary {
          padding: 0.75rem 1.5rem;
          font-size: 0.9rem;
        }
      }
    }

    .container {
      padding: 0 1rem;
    }

    .section-header {
      margin-bottom: 2.5rem;

      h3 {
        font-size: 1.75rem;
      }

      .section-subtitle {
        font-size: 1rem;
      }
    }

    .proven-outcomes {
      padding: 2.5rem 0;

      .proven-content {
        .proven-image {
          height: 250px;
        }

        .proven-content-writeUps {
          .outcome-list {
            .outcome-item {
              .icon-wrapper {
                width: 40px;
                height: 40px;
                font-size: 1.1rem;
              }

              .outcome-text {
                font-size: 0.95rem;
              }
            }
          }

          .btn-secondary {
            padding: 0.75rem 1.5rem;
            font-size: 0.95rem;
          }
        }
      }
    }

    .prototype-sprint-section {
      padding: 2.5rem 0;
      margin: 2.5rem 0;

      .timeline-cards {
        .timeline-card {
          .card-header {
            .card-number {
              width: 35px;
              height: 35px;
              font-size: 0.875rem;
            }
          }

          .card-title {
            font-size: 1.1rem;
          }

          .card-description {
            font-size: 0.95rem;
          }
        }
      }
    }

    .manufacturing-capacity {
      padding: 2.5rem 0;

      .capacity-cards {
        .capacity-card {
          padding: 1.25rem;

          .card-icon {
            width: 55px;
            height: 55px;
            font-size: 1.5rem;
          }

          .card-title {
            font-size: 1.1rem;
          }

          p {
            font-size: 0.95rem;
          }
        }
      }
    }

    .six-development-section {
      padding: 2.5rem 0;
      margin: 2.5rem 0;

      .six-development-image {
        height: 250px;
      }

      .six-development-content {
        h4 {
          font-size: 1.25rem;
        }

        p {
          font-size: 0.95rem;
        }

        .btn-primary {
          padding: 0.75rem 1.5rem;
          font-size: 0.95rem;
        }
      }
    }
  }

  @media screen and (max-width: 420px) {
    .contact-hero-section {
      height: 45vh;

      .hero-content {
        h3 {
          font-size: 1.75rem;
        }

        p {
          font-size: 0.9rem;
        }

        .btn-secondary {
          padding: 0.625rem 1.25rem;
          font-size: 0.85rem;
        }
      }
    }

    .section-header {
      h3 {
        font-size: 1.5rem;
      }

      .section-subtitle {
        font-size: 0.9rem;
      }
    }

    .proven-outcomes {
      .proven-content {
        .proven-image {
          height: 200px;
        }

        .proven-content-writeUps {
          .outcome-list {
            .outcome-item {
              .icon-wrapper {
                width: 35px;
                height: 35px;
                font-size: 1rem;
              }

              .outcome-text {
                font-size: 0.9rem;
              }
            }
          }

          .btn-secondary {
            padding: 0.625rem 1.25rem;
            font-size: 0.85rem;
          }
        }
      }
    }

    .prototype-sprint-section {
      .timeline-cards {
        .timeline-card {
          padding: 1rem;

          .card-header {
            .card-number {
              width: 30px;
              height: 30px;
              font-size: 0.75rem;
            }
          }

          .card-title {
            font-size: 1rem;
          }

          .card-description {
            font-size: 0.9rem;
          }
        }
      }
    }

    .manufacturing-capacity {
      .capacity-cards {
        .capacity-card {
          padding: 1rem;

          .card-icon {
            width: 50px;
            height: 50px;
            font-size: 1.25rem;
          }

          .card-title {
            font-size: 1rem;
          }

          p {
            font-size: 0.9rem;
          }
        }
      }
    }

    .six-development-section {
      .six-development-image {
        height: 200px;
      }

      .six-development-content {
        h4 {
          font-size: 1.1rem;
        }

        p {
          font-size: 0.9rem;
        }

        .btn-primary {
          padding: 0.625rem 1.25rem;
          font-size: 0.85rem;
        }
      }
    }
  }

  @media screen and (max-width: 350px) {
    .contact-hero-section {
      height: 40vh;

      .hero-content {
        h3 {
          font-size: 1.5rem;
        }

        p {
          font-size: 0.85rem;
        }

        .btn-secondary {
          padding: 0.5rem 1rem;
          font-size: 0.8rem;

          svg {
            width: 16px;
            height: 16px;
          }
        }
      }
    }

    .container {
      padding: 0 0.5rem;
    }

    .section-header {
      h3 {
        font-size: 1.25rem;
      }

      .section-subtitle {
        font-size: 0.85rem;
      }

      .btn-primary {
        padding: 0.5rem 1rem;
        font-size: 0.8rem;

        svg {
          width: 16px;
          height: 16px;
        }
      }
    }

    .proven-outcomes {
      .proven-content {
        .proven-image {
          height: 180px;
        }

        .proven-content-writeUps {
          .outcome-list {
            .outcome-item {
              .icon-wrapper {
                width: 30px;
                height: 30px;
                font-size: 0.9rem;
              }

              .outcome-text {
                font-size: 0.85rem;
              }
            }
          }

          .btn-secondary {
            padding: 0.5rem 1rem;
            font-size: 0.8rem;

            svg {
              width: 14px;
              height: 14px;
            }
          }
        }
      }
    }

    .prototype-sprint-section {
      .timeline-cards {
        .timeline-card {
          .card-header {
            .card-number {
              width: 25px;
              height: 25px;
              font-size: 0.7rem;
            }
          }
        }
      }
    }

    .manufacturing-capacity {
      .capacity-cards {
        .capacity-card {
          .card-icon {
            width: 45px;
            height: 45px;
            font-size: 1.1rem;
          }

          .card-title {
            font-size: 0.95rem;
          }

          p {
            font-size: 0.85rem;
          }
        }
      }
    }

    .six-development-section {
      .six-development-image {
        height: 180px;
      }

      .six-development-content {
        h4 {
          font-size: 1rem;
        }

        p {
          font-size: 0.85rem;
        }

        .btn-primary {
          padding: 0.5rem 1rem;
          font-size: 0.8rem;

          svg {
            width: 14px;
            height: 14px;
          }
        }
      }
    }
  }
`;

export default PrototypeSprint;
